module.exports = __webpack_public_path__ + "static/media/r101.e0bcb03c.jpg";